import React from 'react';
import {Anchor, HandHeart, Rainbow, Venus} from 'lucide-react';

const ownership=[
  {label:'Veteran-owned',Icon:Anchor},
  {label:'Black-owned',Icon:HandHeart},
  {label:'Woman-owned',Icon:Venus},
  {label:'LGBT-owned',Icon:Rainbow,rainbow:true},
];

const OwnershipStrip=()=> <section className="px-3 md:px-6 pb-10 md:pb-14" aria-label="Firm ownership identities">
  <div className="max-w-7xl mx-auto rounded-2xl bg-[#071a36] text-white px-6 md:px-8 py-6 flex flex-col lg:flex-row lg:items-center justify-between gap-5">
    <div><p className="text-[10px] uppercase tracking-[.18em] text-[#75b9ff]">Founded & owned by Allison Adams-Jones, CPA</p><p className="font-serif-display text-2xl md:text-3xl mt-2">A practice shaped by experience, service, and belonging.</p></div>
    <div className="flex flex-wrap gap-2">{ownership.map(({label,Icon,rainbow})=><span key={label} className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2.5 text-sm"><span className={rainbow?'grid h-6 w-6 place-items-center rounded-full bg-gradient-to-r from-[#e63946] via-[#f6bd60] to-[#6d5bd0] text-white':'grid h-6 w-6 place-items-center rounded-full bg-[#15345d] text-[#75b9ff]'}><Icon size={14} strokeWidth={1.9} aria-hidden="true"/></span>{label}</span>)}</div>
  </div>
</section>;

export default OwnershipStrip;
